import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  hero: {
    objectFit: "cover",
    width: "100%",
    height: 300,
  },
  wrapHeader: {
    textAlign: "center",
    paddingTop: "70px",
  },
  wrapCard: {
    padding: 20,
  },
  wrapGrid: {
    textAlign: "center",
  },
  wrapList: {
    marginTop: "100px",
  },
  wrapKredit: {
    paddingBottom: "100px",
  },
  liquidTitle: {
    fontWeight: "bold",
    color: theme.palette.textColor.primeTextColor,
  },
  liquidPrimary: {
    fontSize: 13.5,
    fontWeight: "bold",
  },
  liquid: {
    fontSize: 13.5,
    // fontWeight: "bold",
  },
  liquidSecond: {
    fontSize: 13.5,
    color: theme.palette.textColor.gray,
  },
  liquidSecondList: {
    maxWidth: "200px",
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    fontWeight: "bold",
  },
  secondItem: {
    marginTop: "20px",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
  },
  wrapList: {
    marginTop: "90px",
  },
}));

export default useStyles;
